
import React, { useEffect, useState, useRef, useContext } from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import socket from "../Components/socket";
import "../css/landing.css";
import Rightcontainer from "../Components/Rightcontainer";
import Downloadbutton from "../Components/Downloadbutton";
import DownloadPopup from "../Components/DownloadPopup";
import io from "../Components/socket";
import Header from "../Components/Header";
import { Token } from "@mui/icons-material";
import SliderCode from "../Components/SliderCode";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { Carousel } from "react-bootstrap";

export default function Landing({ userAllData }) {
  const [open, setOpen] = useState(false);
  const [showDownloadPopup, setShowDownloadPopup] = useState(true);

  // language
  const translations = {
    hi: { Tournaments: "प्रतियोगिता" },
    en: { Tournaments: "Tournaments" },
  };

  const MyData = localStorage.getItem("udata");
  const meedata = JSON.parse(MyData);
  // console.log(meedata?.verified,"meedata")
  const { language } = useContext(LanguageContext);

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting || "{}");

  useEffect(() => {
    // role()
  }, []);

  // Change theme / Background forced to white as requested
  const theme = localStorage.getItem("theme");

  const styles = {
    backgroundColor: "#ffffff",
    color: "#000000",
  };

  return (
    <>
      <div
        className="leftContainer mb_space mt-4 pt-4"
        style={{ ...styles, minHeight: "100vh" }}
      >
        <div className="pt-3 Orher_page_main_section" style={styles}>
          <div className="main-area" style={styles}>
            {JSON.parse(localStorage.getItem("sitSetting"))?.site_message !=
              null &&
              JSON.parse(localStorage.getItem("sitSetting"))?.site_message !=
                "" && (
                <div className="gameCard pt-2" style={styles}>
                  <div className="alrt_msg_div mt-3">
                    <h5
                      className=""
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#000",
                        margin: 0,
                      }}
                    >
                      {
                        JSON.parse(localStorage.getItem("sitSetting"))
                          ?.site_message
                      }
                    </h5>
                  </div>
                </div>
              )}

            {/* KYC Alert Box (Matching screenshot aesthetic) */}
            {meedata?.verified ==="unverified" ?  <Link
              to="/Profile"
              className="my-3 d-block"
              style={{ textDecoration: "none" }}
            >
              <div
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #ff4d4d",
                  borderRadius: "8px",
                  padding: "12px",
                  textAlign: "center",
                  cursor: "pointer",
                }}
              >
                <span
                  style={{
                    color: "#ff4d4d",
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  Please Complete Your KYC
                </span>
              </div>
            </Link>:"" }
          

            {/* Our Tournaments Header with YouTube button link */}
            <div className="section-divider d-flex align-items-center justify-content-between my-4">
              <span
                className="font-weight-bold"
                style={{
                  letterSpacing: "0.5px",
                  fontSize: "18px",
                  color: "#000",
                }}
              >
                Our Tournaments
              </span>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noreferrer"
                className="btn btn-outline-danger btn-sm d-flex align-items-center gap-1"
                style={{
                  borderRadius: "6px",
                  fontSize: "13px",
                  fontWeight: "600",
                  padding: "4px 10px",
                }}
              >
                <span style={{ color: "#ff0000", fontSize: "16px" }}>▶</span>{" "}
                YouTube
              </a>
            </div>

            <section className="games-section" style={styles}>
              <div className="games-section-headline mt-0 pb-2 mb-sm-5 mb-3">
                <div className="games-window d-flex gap-3 justify-content-between">
                  {/* Ludo Classic */}
                  <Link
                    className="gameCard-container"
                    to="/Homepage/ludoClassicManual"
                    style={{ width: "calc(50% - 8px)" }}
                  >
                    <div className="gameCard">
                      <span className="d-none blink d-block text-right bg_green game_live_status_position">
                        ◉ LIVE
                      </span>

                      <picture className="gameCard-image">
                        <img
                          width="100%"
                          src="./mainimage/ludoclassic.png"
                          alt="Ludo Classic"
                        />
                      </picture>
                    </div>
                  </Link>

                  {/* WhatsApp Support */}
                  <a
                    href={addCaseSetting?.whatsappSupport || "#"}
                    target="_blank"
                    rel="noreferrer"
                    className="gameCard-container"
                    style={{ width: "calc(50% - 8px)" }}
                  >
                    <div className="gameCard">
                      <span className="d-none blink d-block text-right text-danger bg_green game_live_status_position">
                        ◉ LIVE
                      </span>

                      <picture className="gameCard-image">
                        <img
                          width="100%"
                          src="./mainimage/ludosupport.png"
                          alt="WhatsApp Support"
                        />
                      </picture>
                    </div>
                  </a>
                </div>
              </div>
            </section>

            {/* EXPLORE OUR SERVICES Section */}
            <div className="section-divider my-4">
              <span
                className="font-weight-bold"
                style={{
                  letterSpacing: "0.5px",
                  fontSize: "18px",
                  color: "#000",
                  display: "block",
                }}
              >
                EXPLORE OUR SERVICES
              </span>
            </div>

            {/* Services Banner */}
            <div className="services-banner-container mb-4 shadow-sm">
              <img
                src="/banneripl.png"
                className="w-100 rounded"
                alt="Services"
                style={{ display: "block", borderRadius: "8px" }}
              />
            </div>

            <div className="downloadButton mb-4">
              <Downloadbutton />
            </div>
          </div>
        </div>
      </div>

      <div className="rightContainer mobile-hide">
        <Rightcontainer />
      </div>
    </>
  );
}
